import { render, staticRenderFns } from "./PanelProductOrderPerformance.vue?vue&type=template&id=a64bccea&scoped=true"
import script from "./PanelProductOrderPerformance.vue?vue&type=script&lang=js"
export * from "./PanelProductOrderPerformance.vue?vue&type=script&lang=js"
import style0 from "./PanelProductOrderPerformance.vue?vue&type=style&index=0&id=a64bccea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64bccea",
  null
  
)

export default component.exports